import React, { createContext, useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { TYPENAME_MAPPING } from "MyCalendar/components/EventModalV2/modules/Utils";

export const TAB_TYPES = {
  GRADES: "GRADES",
  COURSES: "COURSES",
  STUDENTS: "STUDENTS",
  FAMILY: "FAMILY",
  STAFF: "STAFF",
};

const ParticipantsModalContext = createContext();

export const ParticipantsModalProvider = ({
  children,
  initialTab = TAB_TYPES.STUDENTS,
  eventTitle,
  associatedEntities,
  sharedWith,
  staffCount,
  studentCount,
  familyCount,
  eventType,
}) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [searchText, setSearchText] = useState("");

  const typeName = _.get(associatedEntities, "0.__typename", "");
  const isCustomParticipantList = !TYPENAME_MAPPING[typeName];

  const value = useMemo(
    () => ({
      activeTab,
      setActiveTab,
      searchText,
      setSearchText,
      eventTitle,
      associatedEntities,
      sharedWith,
      staffCount,
      studentCount,
      familyCount,
      isCustomParticipantList,
      eventType,
    }),
    [
      activeTab,
      searchText,
      eventTitle,
      associatedEntities,
      sharedWith,
      staffCount,
      studentCount,
      familyCount,
      isCustomParticipantList,
      eventType,
    ]
  );

  return (
    <ParticipantsModalContext.Provider value={value}>
      {children}
    </ParticipantsModalContext.Provider>
  );
};

ParticipantsModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialTab: PropTypes.string,
  eventTitle: PropTypes.string,
  associatedEntities: PropTypes.array,
  sharedWith: PropTypes.array,
  staffCount: PropTypes.number,
  studentCount: PropTypes.number,
  familyCount: PropTypes.number,
  eventType: PropTypes.string,
};

ParticipantsModalProvider.defaultProps = {
  initialTab: TAB_TYPES.STUDENTS,
  eventTitle: "",
  associatedEntities: [],
  sharedWith: [],
  staffCount: 0,
  studentCount: 0,
  familyCount: 0,
  eventType: undefined,
};

export const useParticipantsModal = () => {
  const context = useContext(ParticipantsModalContext);
  if (!context) {
    throw new Error(
      "useParticipantsModal must be used within a ParticipantsModalProvider"
    );
  }
  return context;
};

export default ParticipantsModalContext;
